<template>
  <div class="py-6">
    <div class="w-full max-w-screen-lg mx-auto px-3">
      <div>
        <div class="my-4">
          <h2 class="font-extrabold text-2xl text-gray-800">
            Rentalcars.com connects you to the biggest brands in car hire.
          </h2>
        </div>
      </div>

      <div>
        <div class="">
          <div class="flex justify-between justify flex-row flex-wrap -mx-4">
            <img
              class="w-20 my-2 mx-3 rounded-md shadow-md"
              src="https://cdn2.rcstatic.com/images/supplier_logos/budget_logo_lrg.gif"
              alt=""
            />
            <img
              class="w-20 my-2 mx-3 rounded-md shadow-md"
              src="https://cdn2.rcstatic.com/images/supplier_logos/europcar_logo_lrg.gif"
              alt=""
            />
            <img
              class="w-20 my-2 mx-3 rounded-md shadow-md"
              src="https://cdn2.rcstatic.com/images/supplier_logos/sixt_logo_lrg.gif"
              alt=""
            />
            <img
              class="w-20 my-2 mx-3 rounded-md shadow-md"
              src="https://cdn2.rcstatic.com/images/supplier_logos/goldcar_logo_lrg.gif"
              alt=""
            />
            <img
              class="w-20 my-2 mx-3 rounded-md shadow-md"
              src="https://cdn2.rcstatic.com/images/supplier_logos/hertz_logo_lrg.gif"
              alt=""
            />
            <img
              class="w-20 my-2 mx-3 rounded-md shadow-md"
              src="https://cdn2.rcstatic.com/images/supplier_logos/avis_logo_lrg.gif"
              alt=""
            />
            <img
              class="w-20 my-2 mx-3 rounded-md shadow-md"
              src="https://cdn2.rcstatic.com/images/supplier_logos/alamo_logo_lrg.gif"
              alt=""
            />
            <img
              class="w-20 my-2 mx-3 rounded-md shadow-md"
              src="https://cdn2.rcstatic.com/images/supplier_logos/thrifty_logo_lrg.gif"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-brand-section',
}
</script>
